<template>
  <v-container fluid>
    <v-app-bar dark app color="primary">
      <v-app-bar-nav-icon>
        <v-icon>mdi-cash-multiple</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>Rechnungen</v-toolbar-title>

      <v-spacer />
      <SearchField
        v-model="search"
        :disabled="$route.name === 'FinanceInvoicesTransfers'"
      ></SearchField>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tabs-slider color="error"></v-tabs-slider>
          <v-tab :to="{ name: 'FinanceInvoicesSubmitted' }">
            <v-badge
              color="info"
              :value="overview && overview.submitted"
              :content="overview.submitted"
              >eingereicht</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesSubmittedSap' }">
            <v-badge
              color="info"
              :value="overview && overview.submittedSap"
              :content="overview.submittedSap"
              >an SAP</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesForeign' }">
            <v-badge
              color="info"
              :value="overview && overview.foreign"
              :content="overview.foreign"
              >Fremdwährung</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesNoDetails' }">
            <v-badge
              color="info"
              :value="overview && overview.noDetails"
              :content="overview.noDetails"
              >unverteilt</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesDepartments' }">
            <v-badge
              color="info"
              :value="overview && overview.department"
              :content="overview.department"
              >FS-Sammlung</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesEntered' }"> verbucht </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesRejected' }"> abgelehnt </v-tab>
          <v-tab :to="{ name: 'FinanceInvoicesTransfers' }">
            umbuchungen
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-card
      ><router-view :search="search" @update="fetchData"></router-view
    ></v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import SearchField from "@/components/SearchField.vue";

export default defineComponent({
  name: "FinanceInvoices",
  components: {
    SearchField,
  },
  data() {
    return {
      search: null,
      overview: {},
    };
  },
  methods: {
    async fetchData() {
      this.overview = await this.apiList({
        resource: "finance/invoiceoverview",
      });
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
